import React from "react";
import styled from "styled-components";

//https://styled-icons.js.org/

import { Star } from "styled-icons/fa-regular/Star";
import { Search } from "styled-icons/fa-solid/Search";
import { UserCircle } from "styled-icons/fa-solid/UserCircle";
import { User } from "styled-icons/fa-solid/User";
import { OndemandVideo } from "styled-icons/material/OndemandVideo";
import { Video } from "styled-icons/feather/Video";
import { Heart } from "styled-icons/feather/Heart";
import { Info } from "styled-icons/feather/Info";
import { Share } from "styled-icons/material/Share";
import { PlusSmall } from "styled-icons/octicons/PlusSmall";
import { ShareAlt } from "styled-icons/fa-solid/ShareAlt";
import { Plus } from "styled-icons/feather/Plus";
import { FacebookF } from "styled-icons/fa-brands/FacebookF";
import { Twitter } from "styled-icons/fa-brands/Twitter";
import { Youtube } from "styled-icons/fa-brands/Youtube";
import { Instagram } from "styled-icons/fa-brands/Instagram";
import { KeyboardArrowRight } from "styled-icons/material/KeyboardArrowRight";
import { KeyboardArrowLeft } from "styled-icons/material/KeyboardArrowLeft";
import { BrokenImage } from "styled-icons/material/BrokenImage";
import { Image } from "styled-icons/feather/Image";
import { Email } from "styled-icons/material/Email";
import { GooglePlusG } from "styled-icons/fa-brands/GooglePlusG";
import { Whatsapp } from "styled-icons/fa-brands/Whatsapp";
import { Bars } from "styled-icons/fa-solid/Bars";
import { Close } from "styled-icons/material/Close";
import { ArrowDropUp } from "styled-icons/material/ArrowDropUp";
import { ArrowDropDown } from "styled-icons/material/ArrowDropDown";
import { ArrowBack } from "styled-icons/material/ArrowBack";
import { PlayCircle as PlayFaCircle } from "styled-icons/fa-regular/PlayCircle";
import { PauseCircle } from "styled-icons/fa-regular/PauseCircle";
import { VolumeUp } from "styled-icons/fa-solid/VolumeUp";
import { VolumeOff } from "styled-icons/fa-solid/VolumeOff";
import { FileDownload } from "styled-icons/material/FileDownload";
import { Backward } from "styled-icons/fa-solid/Backward";
import { Forward } from "styled-icons/fa-solid/Forward";
import { PlayCircleFilled } from "styled-icons/material/PlayCircleFilled";
import { VolumeDown } from "styled-icons/fa-solid/VolumeDown";
import { VolumeMute } from "styled-icons/fa-solid/VolumeMute";
import { PauseCircleFilled } from "styled-icons/material/PauseCircleFilled";
import { Spinner } from "styled-icons/fa-solid/Spinner";
import { FormatListBulleted } from "styled-icons/material/FormatListBulleted";
import { Warning } from "styled-icons/material/Warning";
import { MinusCircle } from "styled-icons/feather/MinusCircle";
import { Error } from "styled-icons/material/Error";
import { ErrorOutline } from "styled-icons/material/ErrorOutline";
import { StepBackward } from "styled-icons/fa-solid/StepBackward";
import { StepForward } from "styled-icons/fa-solid/StepForward";

import Colors from "./Colors";
import { getKey } from "../utils/helpers";

const SvgIcon = styled.svg`
  fill: ${props => props.color || props.fill || Colors.white};
`;
const PauseCircleCustom = ({ size, color, className }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    width={getKey(size, "width", size)}
    height={getKey(size, "height", size)}
    focusable="false"
    role="img"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth="2px"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="10" x2="10" y1="15" y2="9" />
    <line x1="14" x2="14" y1="15" y2="9" />
  </SvgIcon>
);
const Pause = ({ size, color, className }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    width={getKey(size, "width", size)}
    height={getKey(size, "height", size)}
    focusable="false"
    role="img"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth="2px"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="10" x2="10" y1="15" y2="9" />
    <line x1="14" x2="14" y1="15" y2="9" />
  </SvgIcon>
);
const ChevronBottomIcon = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 10"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <polygon fillRule="evenodd" points="6.01 10 .01 0 12.01 0" />
  </SvgIcon>
);
const ChevronBottomIconB = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 10"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <polygon points="12 0 6.00017437 4.51638177 0 0 0 4.60251902 6.00017437 9.11890079 12 4.60251902" />
  </SvgIcon>
);
const chevronRight = styled(ChevronBottomIcon)`
  transform: rotate(-90deg);
`;
const InfoCustom = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path
      className="cls-1"
      d="M623.87,311.93C623.87,139.66,484.21,0,311.93,0S0,139.66,0,311.93,139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93Zm-585.34,0c0-151,122.41-273.4,273.4-273.4s273.41,122.41,273.41,273.4S462.93,585.34,311.93,585.34,38.53,462.93,38.53,311.93Z"
    />
    <circle cx="311.65" cy="191.75" r="18.82" />
    <rect
      x="205.28"
      y="325.18"
      width="213.91"
      height="37.61"
      rx="18.8"
      ry="18.8"
      transform="translate(656.22 31.74) rotate(90)"
    />
  </SvgIcon>
);

const ShareCustom = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path d="M275.68,311.92a57.08,57.08,0,0,1-3.42,19.34l91,43.78a57.2,57.2,0,1,1-15.06,38.59,56.38,56.38,0,0,1,.77-8.88l-96.87-46.6a57.28,57.28,0,1,1,0-92.44L349,219.12a56.38,56.38,0,0,1-.77-8.88,57.46,57.46,0,1,1,15.05,38.6l-91,43.75a57.19,57.19,0,0,1,3.42,19.33Z" />
    <path
      className="cls-1"
      d="M311.93,0C139.66,0,0,139.66,0,311.93S139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93,484.21,0,311.93,0Zm0,585.34c-151,0-273.4-122.41-273.4-273.41s122.41-273.4,273.4-273.4,273.41,122.41,273.41,273.4S462.93,585.34,311.93,585.34Z"
    />
  </SvgIcon>
);
const CloseO = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    width={size}
    height={size}
    aria-hidden={true}
    color={"#121212"}
    className={className}
  >
    <path
      transform="translate(-1122 -458)"
      className="cls-1"
      d="M1139.5,493a17.444,17.444,0,0,1-6.4-1.2,1.166,1.166,0,1,1,.85-2.171,15.176,15.176,0,0,0,16.48-24.649,1.166,1.166,0,1,1,1.68-1.617A17.506,17.506,0,0,1,1139.5,493Zm-8.84-2.592a1.136,1.136,0,0,1-.63-0.186c-0.21-.134-0.41-0.272-0.61-0.414a1.164,1.164,0,0,1,1.34-1.9c0.18,0.124.36,0.243,0.53,0.359A1.164,1.164,0,0,1,1130.66,490.409Zm-3.11-2.6a1.161,1.161,0,0,1-.85-0.371,17.506,17.506,0,0,1,12.8-29.452,1.166,1.166,0,0,1,0,2.332,15.176,15.176,0,0,0-11.1,25.529A1.163,1.163,0,0,1,1127.55,487.811Zm20.33-25.176a1.177,1.177,0,0,1-.6-0.165,15.183,15.183,0,0,0-2.81-1.318,16.419,16.419,0,0,0-1.7-.478,1.164,1.164,0,0,1-.89-1.388,1.179,1.179,0,0,1,1.39-.889,17.332,17.332,0,0,1,5.21,2.073,1.159,1.159,0,0,1,.4,1.6A1.147,1.147,0,0,1,1147.88,462.635Zm-6.47,13.436-1.34,1.335,6.24,6.237a0.945,0.945,0,1,0,1.34-1.333Zm6.24-8.725a0.951,0.951,0,0,0-1.34,0l-6.81,6.816-6.82-6.816a0.942,0.942,0,1,0-1.33,1.335l6.81,6.814-6.81,6.815a0.939,0.939,0,0,0,0,1.333,0.934,0.934,0,0,0,1.33,0l14.97-14.962A0.96,0.96,0,0,0,1147.65,467.346Z"
    />
  </SvgIcon>
);
const CloseCircle = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    aria-hidden={true}
    color={"#ffffff"}
    className={className}
  >
    <path d="m256 512c-141.160156 0-256-114.839844-256-256s114.839844-256 256-256 256 114.839844 256 256-114.839844 256-256 256zm0-475.429688c-120.992188 0-219.429688 98.4375-219.429688 219.429688s98.4375 219.429688 219.429688 219.429688 219.429688-98.4375 219.429688-219.429688-98.4375-219.429688-219.429688-219.429688zm0 0" />
    <path d="m347.429688 365.714844c-4.679688 0-9.359376-1.785156-12.929688-5.359375l-182.855469-182.855469c-7.144531-7.144531-7.144531-18.714844 0-25.855469 7.140625-7.140625 18.714844-7.144531 25.855469 0l182.855469 182.855469c7.144531 7.144531 7.144531 18.714844 0 25.855469-3.570313 3.574219-8.246094 5.359375-12.925781 5.359375zm0 0" />
    <path d="m164.570312 365.714844c-4.679687 0-9.355468-1.785156-12.925781-5.359375-7.144531-7.140625-7.144531-18.714844 0-25.855469l182.855469-182.855469c7.144531-7.144531 18.714844-7.144531 25.855469 0 7.140625 7.140625 7.144531 18.714844 0 25.855469l-182.855469 182.855469c-3.570312 3.574219-8.25 5.359375-12.929688 5.359375zm0 0" />
  </SvgIcon>
);
const LikeDeselectedCustom = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path d="M444.69,363.94c6-7.6,8.81-15.74,8.45-24.13a37.07,37.07,0,0,0-7.9-20.91c4-9.85,5.47-25.35-7.72-37.38-9.67-8.82-26.08-12.77-48.81-11.67a190.68,190.68,0,0,0-29.91,3.83h-.06c-3,.55-6.26,1.21-9.55,1.94-.24-3.89.43-13.56,7.6-35.32,8.51-25.89,8-45.71-1.58-59-10.09-13.92-26.2-15-30.94-15a15.26,15.26,0,0,0-11.73,5.35c-6.75,7.84-6,22.31-5.11,29-8,21.52-30.51,74.28-49.54,88.93a6.51,6.51,0,0,0-1,.85A65.25,65.25,0,0,0,245,308.32a25.11,25.11,0,0,0-12-3H195.89a25.31,25.31,0,0,0-25.29,25.29v98.78a25.31,25.31,0,0,0,25.29,25.29H233A25.24,25.24,0,0,0,247.56,450l14.28,1.7c2.19.3,41.09,5.23,81,4.44,7.23.55,14,.85,20.36.85a136.27,136.27,0,0,0,28.27-2.55c18.6-4,31.31-11.85,37.75-23.46a37.21,37.21,0,0,0,4.14-23.28c12.1-10.94,14.22-23,13.8-31.55a41.11,41.11,0,0,0-2.49-12.22Zm-248.8,74.28a8.89,8.89,0,0,1-8.87-8.87V330.5a8.89,8.89,0,0,1,8.87-8.87H233a8.89,8.89,0,0,1,8.88,8.87v98.78a8.89,8.89,0,0,1-8.88,8.88H195.89Zm233.24-81.39" />
    <path
      className="cls-1"
      d="M623.87,311.93C623.87,139.66,484.21,0,311.93,0S0,139.66,0,311.93,139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93Zm-585.34,0c0-151,122.41-273.4,273.4-273.4s273.4,122.41,273.4,273.4-122.41,273.4-273.4,273.4S38.53,462.93,38.53,311.93Z"
    />
  </SvgIcon>
);

const DislikeDeselectedCustom = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path d="M179.18,259.93c-6,7.6-8.81,15.74-8.45,24.13a37.07,37.07,0,0,0,7.9,20.91c-4,9.85-5.47,25.35,7.72,37.38,9.67,8.82,26.08,12.77,48.81,11.67a190.68,190.68,0,0,0,29.91-3.83h.06c3-.55,6.26-1.21,9.55-1.94.24,3.89-.43,13.56-7.6,35.32-8.51,25.89-8,45.71,1.58,59,10.09,13.92,26.2,15,30.94,15a15.26,15.26,0,0,0,11.73-5.35c6.75-7.84,6-22.31,5.11-29,8-21.52,30.51-74.28,49.54-88.93a6.51,6.51,0,0,0,1-.85,65.25,65.25,0,0,0,11.91-17.87,25.11,25.11,0,0,0,12,3H428a25.31,25.31,0,0,0,25.29-25.29V194.52A25.31,25.31,0,0,0,428,169.24H390.9a25.24,25.24,0,0,0-14.59,4.62L362,172.15c-2.19-.3-41.09-5.23-81-4.44-7.23-.55-14-.85-20.36-.85a136.27,136.27,0,0,0-28.27,2.55c-18.6,4-31.31,11.85-37.75,23.46a37.21,37.21,0,0,0-4.14,23.28c-12.1,10.94-14.22,23-13.8,31.55a41.11,41.11,0,0,0,2.49,12.22ZM428,185.65a8.89,8.89,0,0,1,8.87,8.87v98.84a8.89,8.89,0,0,1-8.87,8.87H390.9a8.89,8.89,0,0,1-8.88-8.87V194.59a8.89,8.89,0,0,1,8.88-8.88H428ZM194.74,267" />
    <path
      className="cls-1"
      d="M0,311.93C0,484.21,139.66,623.87,311.93,623.87S623.87,484.21,623.87,311.93,484.21,0,311.93,0,0,139.66,0,311.93Zm585.34,0c0,151-122.41,273.4-273.4,273.4S38.53,462.93,38.53,311.93s122.41-273.4,273.4-273.4S585.34,160.94,585.34,311.93Z"
    />
  </SvgIcon>
);

const MyListCustom = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path
      className="cls-1"
      d="M311.93,0C139.66,0,0,139.66,0,311.93S139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93,484.21,0,311.93,0Zm0,585.34c-151,0-273.4-122.41-273.4-273.4s122.41-273.4,273.4-273.4,273.4,122.41,273.4,273.4S462.93,585.34,311.93,585.34Z"
    />
    <rect
      className="cls-1"
      x="153.8"
      y="293.13"
      width="316.28"
      height="37.61"
      rx="18.8"
      ry="18.8"
      transform="translate(623.87 0) rotate(90)"
    />
    <rect
      className="cls-1"
      x="153.8"
      y="293.13"
      width="316.28"
      height="37.61"
      rx="18.8"
      ry="18.8"
    />
  </SvgIcon>
);

const Trailer = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path
      className="cls-1"
      d="M311.93,0C139.66,0,0,139.66,0,311.93S139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93,484.21,0,311.93,0Zm0,585.34c-151,0-273.4-122.41-273.4-273.41s122.41-273.4,273.4-273.4,273.41,122.41,273.41,273.4S462.93,585.34,311.93,585.34Z"
    />
    <polygon
      className="cls-2"
      points="343.33 187.16 300.64 187.16 281.39 224.69 321.61 224.69 343.33 187.16"
    />
    <polygon
      className="cls-2"
      points="416.12 187.16 373.43 187.16 354.18 224.69 394.39 224.69 416.12 187.16"
    />
    <polygon
      className="cls-2"
      points="471.44 187.16 446.23 187.16 426.97 224.69 471.44 224.69 471.44 187.16"
    />
    <polygon
      className="cls-2"
      points="270.53 187.72 151.57 187.72 151.57 198.28 151.57 224.69 248.81 224.69 270.53 187.72"
    />
    <path
      className="cls-2"
      d="M152.42,413a23.69,23.69,0,0,0,23.7,23.69H448.61A23.69,23.69,0,0,0,472.3,413V249.12H152.42Zm119.75-92.8c0-13.09,9.49-18.95,21.19-13.1l50.41,25.2c11.7,5.85,11.7,15.34,0,21.2l-50.41,25.2c-11.7,5.85-21.19,0-21.19-13.1Z"
    />
  </SvgIcon>
);
const Speaker = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path d="M224.12,253.78H167.2a14.4,14.4,0,0,0-14.39,14.4v87.51a14.4,14.4,0,0,0,14.39,14.4h56.92a14.5,14.5,0,0,1,7.31,2L322.65,457a14.39,14.39,0,0,0,21.68-12.43V179.26a14.38,14.38,0,0,0-21.68-12.39l-91.22,84.95a14.59,14.59,0,0,1-7.31,2Z" />
    <path
      stroke={color || Colors.white}
      strokeMiterlimit="10"
      strokeWidth="8"
      d="M395.93,404.56a6.84,6.84,0,0,1-4.84-11.66,109.66,109.66,0,0,0,0-154.82,6.83,6.83,0,1,1,9.66-9.65,123.22,123.22,0,0,1,0,174.12,6.78,6.78,0,0,1-4.82,2Z"
    />
    <path
      stroke={color || Colors.white}
      strokeMiterlimit="10"
      strokeWidth="8"
      d="M426,438.5a6.86,6.86,0,0,1-4.84-11.7,157.58,157.58,0,0,0,0-222.92,6.82,6.82,0,0,1,9.65-9.65,171.14,171.14,0,0,1,0,242.26,6.75,6.75,0,0,1-4.81,2Z"
    />
    <path d="M311.93,0C139.66,0,0,139.66,0,311.93S139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93,484.21,0,311.93,0Zm0,585.34c-151,0-273.4-122.41-273.4-273.41s122.41-273.4,273.4-273.4,273.41,122.41,273.41,273.4S462.93,585.34,311.93,585.34Z" />
  </SvgIcon>
);
const SpeakerNew = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <defs>
      <rect id="i" x="844.3" y="5906.6" width="361.92" height="408.32" />
    </defs>
    <path
      className="st0"
      d="m1201 6242.9c-34.59-34.4-52.14-75.07-52.14-120.96v-66.77c0.33-50.89-33.93-84.68-63.33-98.09-8.41-3.88-17.11-6.86-25.96-9.03v-4.28c0-20.48-16.64-37.12-37.12-37.12-20.44 0-37.12 16.64-37.12 37.12v4.89c-7.93 2.18-15.77 4.96-23.34 8.45-32.52 15.01-65.43 51.11-65.72 98.02v66.81c0 47.42-16.75 88.12-49.82 120.96-1.96 1.96-2.68 4.83-1.85 7.47 0.84 2.68 3.08 4.64 5.84 5.11l70.47 12.14c13.12 2.29 25.2 4.14 36.68 5.66 12.97 25.41 38.43 41.69 66.23 41.69s53.25-16.31 66.18-41.72c11.46-1.52 23.5-3.37 36.54-5.62l70.43-12.14c2.76-0.47 5-2.47 5.84-5.11 0.87-2.66 0.14-5.53-1.81-7.48zm-200.79-299.13c0-12.29 9.97-22.25 22.25-22.25 12.29 0 22.3 9.97 22.3 22.25v1.35c-14.83-2.11-29.84-2.03-44.55 0.36v-1.71zm23.64 356.33c-18.82 0-36.36-9.31-47.67-24.61 16.6 1.74 32.08 2.57 47.56 2.57 15.55 0 31.11-0.83 47.74-2.57-11.27 15.3-28.86 24.61-47.63 24.61zm100.19-47.09"
    />
    <path
      className="st1"
      d="m1027.5 5994.3c-18.12-8.29-40.32-8.29-58.33 0-10.28 4.75-27.69 18.6-27.82 40.51-0.02 2.58 2.05 4.68 4.64 4.71h0.02c2.58 0 4.68-2.08 4.68-4.66 0.12-17.21 14.12-28.24 22.39-32.06 15.58-7.17 34.84-7.17 50.54 0 2.35 1.08 5.12 0.05 6.19-2.3s0.04-5.12-2.31-6.2z"
    />
    <path d="m1014.7 5815.8c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0.01-172.27-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m1172.9-74.08c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m3543.4-99.63c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4z" />
    <circle cx="3423.2" cy="132.29" r="18.82" />
    <circle cx="3423.2" cy="212.3" r="18.82" />
    <circle cx="3423.2" cy="292.32" r="18.82" />
    <path d="m3663.6 230.52h-176.3c-10.34 0-18.8-8.46-18.8-18.8s8.46-18.8 18.8-18.8h176.3c10.34 0 18.8 8.46 18.8 18.8s-8.46 18.8-18.8 18.8z" />
    <path d="m3663.6 151.1h-176.3c-10.34 0-18.8-8.46-18.8-18.8s8.46-18.8 18.8-18.8h176.3c10.34 0 18.8 8.46 18.8 18.8s-8.46 18.8-18.8 18.8z" />
    <path d="m3663.6 309.93h-176.3c-10.34 0-18.8-8.46-18.8-18.8s8.46-18.8 18.8-18.8h176.3c10.34 0 18.8 8.46 18.8 18.8s-8.46 18.8-18.8 18.8z" />
    <path d="m1272.4 252.75l-140.45 87.78c-2.84 1.77-6.07 2.67-9.31 2.67-2.92 0-5.86-0.73-8.51-2.21-5.58-3.09-9.04-8.96-9.04-15.35v-175.56c0-6.39 3.46-12.26 9.04-15.36 5.58-3.11 12.4-2.92 17.82 0.47l140.46 87.78c5.13 3.22 8.25 8.84 8.25 14.89-0.01 6.05-3.13 11.68-8.26 14.89z" />
    <path d="m2770.6 3658.8c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4 0-151 122.41-273.4 273.4-273.4s273.4 122.41 273.4 273.4c0.01 150.99-122.4 273.4-273.4 273.4z" />
    <path d="m2870.1 3985.6l-140.46 87.78c-2.84 1.77-6.07 2.67-9.31 2.67-2.92 0-5.86-0.73-8.51-2.21-5.58-3.09-9.04-8.96-9.04-15.35v-175.57c0-6.39 3.46-12.26 9.04-15.36 5.58-3.11 12.4-2.92 17.82 0.47l140.46 87.78c5.13 3.22 8.25 8.84 8.25 14.89 0.01 6.06-3.12 11.68-8.25 14.9z" />
    <path d="m1925 224.35c0 6.81-1.24 13.29-3.42 19.35l91 43.78c10.47-11.46 25.49-18.68 42.24-18.68 31.63 0 57.28 25.64 57.28 57.27s-25.65 57.29-57.29 57.29c-31.63 0-57.29-25.65-57.29-57.29 0-3.03 0.31-5.99 0.76-8.88l-96.87-46.6c-9.47 6.93-21.1 11.07-33.73 11.07-31.64 0-57.29-25.64-57.29-57.3 0-31.63 25.65-57.26 57.29-57.26 12.63 0 24.27 4.13 33.74 11.06l96.87-46.59c-0.46-2.9-0.76-5.85-0.76-8.88 0-31.65 25.65-57.29 57.29-57.29 31.63 0 57.28 25.64 57.28 57.29 0 31.64-25.65 57.29-57.28 57.29-16.74 0-31.76-7.24-42.24-18.69l-91 43.76c2.17 6.04 3.42 12.52 3.42 19.3z" />
    <path d="m1961.2-87.56c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.33c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m1210.1 2168.4c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.66-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4z" />
    <path d="m1277.3 2480.5h-43.93v156.64h-65.12v-156.64h-30.96v-55.34h30.96v-35.8c0-25.61 12.15-65.7 65.69-65.7l48.24 0.2v53.71h-35c-5.75 0-13.81 2.86-13.81 15.06v32.58h49.6l-5.67 55.29z" />
    <path d="m1927.6-957.85h-56.92c-7.94 0-14.39 6.45-14.39 14.4v87.51c0 7.95 6.45 14.4 14.39 14.4h56.92c2.57 0 5.07 0.67 7.31 1.97l91.22 84.94c9.59 5.64 21.68-1.27 21.68-12.43v-265.3c0-11.12-12.09-18.03-21.68-12.39l-91.22 84.94c-2.24 1.3-4.75 1.96-7.31 1.96z" />
    <path
      className="st2"
      d="m2099.4-807.07c-1.77 0-3.51-0.67-4.84-2.01-2.68-2.67-2.68-6.98 0-9.65 42.65-42.69 42.65-112.13 0-154.82-2.68-2.67-2.68-6.98 0-9.65 2.67-2.67 6.98-2.67 9.65 0 48.03 48 48.03 126.12 0 174.12-1.33 1.34-3.07 2.01-4.81 2.01z"
    />
    <path
      className="st2"
      d="m2129.5-773.13c-1.77 0-3.51-0.68-4.84-2.01-2.68-2.67-2.68-7.01 0-9.69 29.79-29.79 46.19-69.37 46.19-111.46s-16.4-81.67-46.19-111.46c-2.68-2.67-2.68-6.98 0-9.65 2.67-2.67 6.98-2.67 9.65 0 32.4 32.36 50.24 75.39 50.24 121.11 0 45.73-17.84 88.75-50.24 121.15-1.3 1.33-3.07 2.01-4.81 2.01z"
    />
    <path d="m2015.4-1211.6c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m2599 5834.2c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0.01-172.27-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m2727.9 6297.6h-257.71c-10.34 0-18.8-8.46-18.8-18.8v-14.31c0-10.34 8.46-18.81 18.8-18.81h257.71c10.34 0 18.8 8.46 18.8 18.81v14.31c0 10.33-8.46 18.8-18.8 18.8z" />
    <path d="m2586.9 6200.8l-71.53-114.45c-1.45-2.31-2.18-4.95-2.18-7.58 0-2.38 0.59-4.77 1.8-6.93 2.52-4.55 7.3-7.37 12.51-7.37h143.06c5.2 0 9.99 2.82 12.51 7.37 2.54 4.55 2.38 10.11-0.38 14.52l-71.53 114.45c-2.62 4.18-7.2 6.72-12.13 6.72-4.93-0.01-9.52-2.55-12.13-6.73z" />
    <path d="m2630.4 6135.7h-62.8c-6.6 0-12-5.4-12-12v-117.11c0-6.6 5.4-12 12-12h62.8c6.6 0 12 5.4 12 12v117.11c0 6.6-5.4 12-12 12z" />
    <path d="m1771.9 5815.8c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0.01-172.27-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m1891.7 6169.2h-125.68c-10.34 0-18.8-8.46-18.8-18.8v-8.57c0-10.34 8.46-18.8 18.8-18.8h125.68c10.34 0 18.8 8.46 18.8 18.8v8.57c0.01 10.34-8.46 18.8-18.8 18.8z" />
    <path d="m1793.4 5922.9v225.02c0 10.34-8.46 18.8-18.8 18.8h-8.57c-10.34 0-18.8-8.46-18.8-18.8v-225.02c0-10.34 8.46-18.8 18.8-18.8h8.57c10.34 0 18.8 8.46 18.8 18.8z" />
    <path d="m1933.9 4599.7c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0.01-172.27-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m5445 2315.5h-147.8c-50.2 0-91.03 40.83-91.03 91.03v147.8c0 50.2 40.83 91.03 91.03 91.03h147.8c50.2 0 91.03-40.84 91.03-91.03v-147.8c0-50.2-40.83-91.03-91.03-91.03zm61.77 238.83c0 34.06-27.7 61.76-61.76 61.76h-147.8c-34.06 0-61.76-27.7-61.76-61.76v-147.8c0-34.06 27.7-61.76 61.76-61.76h147.8c34.06 0 61.76 27.71 61.76 61.76v147.8z" />
    <path d="m5371.1 2395.5c-46.87 0-85 38.13-85 84.99 0 46.87 38.13 85 85 85 46.86 0 85-38.13 85-85 0-46.86-38.13-84.99-85-84.99zm0 140.71c-30.72 0-55.73-24.99-55.73-55.72 0-30.72 25-55.73 55.73-55.73s55.73 25.01 55.73 55.73c0.01 30.73-25 55.72-55.73 55.72z" />
    <path d="m5459.6 2370.6c-5.64 0-11.18 2.28-15.16 6.28-4.01 3.98-6.31 9.53-6.31 15.19 0 5.64 2.3 11.17 6.31 15.17 3.97 3.98 9.52 6.28 15.16 6.28 5.66 0 11.17-2.3 15.17-6.28 4-4 6.29-9.55 6.29-15.17 0-5.66-2.29-11.2-6.29-15.19-3.98-4-9.51-6.28-15.17-6.28z" />
    <path d="m5371.8 2168.5c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m2235.3 2360.7c-14.17 6.31-29.45 10.55-45.45 12.45 16.34-9.78 28.87-25.28 34.77-43.78-15.24 9.08-32.19 15.66-50.2 19.22-14.46-15.38-35.01-25.01-57.81-25.01-43.7 0-79.13 35.44-79.13 79.15 0 6.2 0.71 12.24 2.04 18.03-65.74-3.3-124.06-34.81-163.09-82.69-6.82 11.68-10.72 25.29-10.72 39.78 0 27.46 13.97 51.67 35.2 65.87-12.96-0.41-25.16-3.96-35.83-9.89-0.01 0.32-0.01 0.67-0.01 0.99 0 38.35 27.28 70.31 63.48 77.58-6.63 1.82-13.63 2.79-20.86 2.79-5.11 0-10.05-0.51-14.89-1.41 10.08 31.43 39.29 54.31 73.92 54.94-27.09 21.22-61.19 33.88-98.27 33.88-6.39 0-12.7-0.37-18.87-1.12 35 22.47 76.61 35.58 121.29 35.58 145.56 0 225.14-120.58 225.14-225.18 0-3.43-0.07-6.85-0.21-10.24 15.5-11.13 28.89-25.07 39.5-40.94z" />
    <path d="m2042.5 2168.4c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.66-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4z" />
    <path d="m3707.2 2168.4c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <defs>
      <rect id="g" x="3543.4" y="2365.8" width="327.63" height="226.3" />
    </defs>
    <path
      className="st3"
      d="m3707.9 2497.5h0.06c2.48 0 4.93-0.72 6.9-2.02l0.54-0.34c0.12-0.09 0.23-0.15 0.37-0.23l6.24-5.19 149.29-123.19c-0.28-0.42-0.83-0.71-1.4-0.71h-324.86c-0.39 0-0.77 0.14-1.08 0.39l156.21 128.72c1.97 1.62 4.77 2.57 7.73 2.57zm-164.59-114.24v182.62l111.9-90.4-111.9-92.22zm216.58 92.85l111.76 89.83v-182.08l-111.76 92.25zm-35.53 29.31c-4.48 3.65-10.29 5.67-16.43 5.67s-11.95-1.99-16.4-5.64l-25.64-21.13-122.59 99.01v0.31c0 0.94 0.8 1.74 1.77 1.74h324.86c0.91 0 1.72-0.8 1.72-1.74v-0.28l-122.48-98.41-24.81 20.47z"
    />
    <path d="m2063.2 4819.9h-256.39c-5.25 0-9.55 4.3-9.55 9.55v21.36h244.4c5.25 0 9.55 4.3 9.55 9.55v138.84h11.99c5.25 0 9.55-4.3 9.55-9.55v-160.21c0-5.24-4.3-9.54-9.55-9.54z" />
    <path d="m2027.7 5043.1h-251.49c-6.6 0-12-5.4-12-12v-155.3c0-6.6 5.4-12 12-12h251.49c6.6 0 12 5.4 12 12v155.3c0 6.6-5.4 12-12 12z" />
    <path d="m2095.3 4780.2h-225.67c-4.62 0-8.4 3.78-8.4 8.4v18.8h215.12c4.62 0 8.4 3.78 8.4 8.4v122.21h10.55c4.62 0 8.4-3.78 8.4-8.4v-141.01c0.01-4.62-3.77-8.4-8.4-8.4z" />
    <path d="m3440.5 6132.5h-110.15c-6.6 0-12-5.4-12-12v-77.09c0-6.6 5.4-12 12-12h110.15c6.6 0 12 5.4 12 12v77.09c0 6.6-5.4 12-12 12z" />
    <path d="m3606.6 6132.5h-110.15c-6.6 0-12-5.4-12-12v-77.09c0-6.6 5.4-12 12-12h110.15c6.6 0 12 5.4 12 12v77.09c0 6.6-5.4 12-12 12z" />
    <path d="m3440.5 6260.8h-110.15c-6.6 0-12-5.4-12-12v-77.09c0-6.6 5.4-12 12-12h110.15c6.6 0 12 5.4 12 12v77.09c0 6.6-5.4 12-12 12z" />
    <path d="m3606.6 6260.8h-110.15c-6.6 0-12-5.4-12-12v-77.09c0-6.6 5.4-12 12-12h110.15c6.6 0 12 5.4 12 12v77.09c0 6.6-5.4 12-12 12z" />
    <path d="m3468.4 5834.2c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0.01-172.27-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <defs>
      <rect id="e" x="1874.1" y="1133.1" width="282.66" height="291.6" />
    </defs>
    <path
      className="st4"
      d="m2148.2 1330.9c5.96-7.6 8.81-15.74 8.45-24.13-0.37-9.24-4.5-16.47-7.9-20.91 3.95-9.85 5.47-25.35-7.72-37.38-9.67-8.82-26.08-12.77-48.81-11.67-15.99 0.73-29.36 3.71-29.91 3.83h-0.06c-3.04 0.55-6.26 1.21-9.55 1.94-0.24-3.89 0.43-13.56 7.6-35.32 8.51-25.89 8.03-45.71-1.58-58.96-10.09-13.92-26.2-15.02-30.94-15.02-4.56 0-8.75 1.88-11.73 5.35-6.75 7.84-5.96 22.31-5.11 29-8.02 21.52-30.51 74.28-49.54 88.93-0.37 0.24-0.67 0.55-0.97 0.85-5.6 5.9-9.36 12.28-11.91 17.87-3.59-1.94-7.66-3.04-12.04-3.04h-37.08c-13.98 0-25.29 11.37-25.29 25.29v98.78c0 13.98 11.37 25.29 25.29 25.29h37.08c5.41 0 10.46-1.7 14.59-4.62l14.28 1.7c2.19 0.3 41.09 5.23 81.03 4.44 7.23 0.55 14.04 0.85 20.36 0.85 10.88 0 20.36-0.85 28.27-2.55 18.6-3.95 31.31-11.85 37.75-23.46 4.92-8.87 4.92-17.69 4.14-23.28 12.1-10.94 14.22-23.04 13.8-31.55-0.25-4.93-1.35-9.13-2.5-12.23zm-248.8 74.28c-4.92 0-8.87-4.01-8.87-8.87v-98.84c0-4.92 4.01-8.87 8.87-8.87h37.08c4.92 0 8.88 4.01 8.88 8.87v98.78c0 4.92-4.01 8.88-8.88 8.88h-37.08v0.05zm233.24-81.39c-2.55 2.67-3.04 6.75-1.09 9.91 0 0.06 2.49 4.32 2.8 10.15 0.42 7.96-3.4 15.01-11.43 21.03-2.86 2.19-4.01 5.96-2.8 9.36 0 0.06 2.61 8.09-1.64 15.68-4.08 7.29-13.13 12.52-26.87 15.44-11 2.37-25.96 2.8-44.31 1.34h-0.85c-39.09 0.85-78.6-4.26-79.02-4.32h-0.06l-6.14-0.73c0.36-1.7 0.55-3.53 0.55-5.35v-98.84c0-2.61-0.42-5.16-1.15-7.54 1.09-4.07 4.13-13.13 11.31-20.85 27.29-21.64 53.98-94.64 55.14-97.81 0.49-1.28 0.61-2.67 0.37-4.07-1.04-6.81-0.67-15.14 0.79-17.63 3.22 0.06 11.91 0.97 17.14 8.2 6.2 8.57 5.96 23.89-0.73 44.19-10.21 30.94-11.06 47.23-2.98 54.41 4.01 3.59 9.36 3.77 13.25 2.37 3.71-0.85 7.23-1.58 10.58-2.13 0.24-0.06 0.55-0.12 0.79-0.18 18.66-4.07 52.1-6.56 63.7 4.01 9.85 9 2.86 20.91 2.07 22.19-2.25 3.4-1.58 7.84 1.46 10.58 0.06 0.06 6.44 6.08 6.75 14.16 0.21 5.42-2.35 10.96-7.63 16.43z"
    />
    <path d="m2327.4 1278.9c0-172.28-139.66-311.93-311.93-311.93s-311.93 139.66-311.93 311.93 139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93zm-585.33 0c0-151 122.41-273.4 273.4-273.4s273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4-273.4-122.41-273.4-273.4z" />
    <defs>
      <rect id="c" x="1071.8" y="1125.2" width="282.66" height="291.6" />
    </defs>
    <path
      className="st5"
      d="m1345.8 1323c5.96-7.6 8.81-15.74 8.45-24.13-0.37-9.24-4.5-16.47-7.9-20.91 3.95-9.85 5.47-25.35-7.72-37.38-9.67-8.82-26.08-12.77-48.81-11.67-15.99 0.73-29.36 3.71-29.91 3.83h-0.06c-3.04 0.55-6.26 1.21-9.55 1.94-0.24-3.89 0.43-13.56 7.6-35.32 8.51-25.89 8.03-45.71-1.58-58.96-10.09-13.92-26.2-15.02-30.94-15.02-4.56 0-8.75 1.88-11.73 5.35-6.75 7.84-5.96 22.31-5.11 29-8.02 21.52-30.51 74.28-49.54 88.93-0.37 0.24-0.67 0.55-0.97 0.85-5.6 5.9-9.36 12.28-11.91 17.87-3.59-1.94-7.66-3.04-12.04-3.04h-37.08c-13.98 0-25.29 11.37-25.29 25.29v98.78c0 13.98 11.37 25.29 25.29 25.29h37.08c5.41 0 10.46-1.7 14.59-4.62l14.28 1.7c2.19 0.3 41.09 5.23 81.03 4.44 7.23 0.55 14.04 0.85 20.36 0.85 10.88 0 20.36-0.85 28.27-2.55 18.6-3.95 31.31-11.85 37.75-23.46 4.92-8.87 4.92-17.69 4.14-23.28 12.1-10.94 14.22-23.04 13.8-31.55-0.25-4.93-1.34-9.13-2.5-12.23zm-248.8 74.29c-4.92 0-8.87-4.01-8.87-8.87v-98.84c0-4.92 4.01-8.87 8.87-8.87h37.08c4.92 0 8.88 4.01 8.88 8.87v98.78c0 4.92-4.01 8.88-8.88 8.88h-37.08v0.05zm233.24-81.4"
    />
    <path d="m1525 1271c0-172.28-139.66-311.93-311.93-311.93s-311.93 139.66-311.93 311.93 139.66 311.93 311.93 311.93 311.93-139.65 311.93-311.93zm-585.34 0c0-151 122.41-273.4 273.4-273.4s273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4-273.4-122.4-273.4-273.4z" />
    <path d="m2768-84.82c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m2749.2 366.45v-278.67c0-10.34 8.46-18.8 18.8-18.8s18.8 8.46 18.8 18.8v278.67c0 10.34-8.46 18.8-18.8 18.8-10.34 0.01-18.8-8.46-18.8-18.8z" />
    <path d="m2907.4 245.92h-278.67c-10.34 0-18.8-8.46-18.8-18.8s8.46-18.8 18.8-18.8h278.67c10.34 0 18.8 8.46 18.8 18.8s-8.46 18.8-18.8 18.8z" />
    <defs>
      <rect id="a" x="4146.6" y="5985.4" width="334.58" height="277.86" />
    </defs>
    <path
      className="st6"
      d="m4346.3 6032.3c15.3 9.6 26.04 25.84 27.99 44.7 6.23 2.9 13.17 4.57 20.51 4.57 26.81 0 48.55-21.72 48.55-48.52 0-26.82-21.74-48.55-48.55-48.55-26.55 0.01-48.09 21.34-48.5 47.8zm-31.81 99.4c26.83 0 48.55-21.72 48.55-48.54 0-26.8-21.72-48.52-48.55-48.52-26.8 0-48.55 21.72-48.55 48.55 0.01 26.79 21.75 48.51 48.55 48.51zm20.6 3.31h-41.19c-34.27 0-62.16 27.89-62.16 62.16v50.38l0.14 0.78 3.47 1.09c32.69 10.21 61.11 13.62 84.51 13.62 45.68 0 72.15-13.01 73.8-13.86l3.23-1.63h0.35v-50.38c0.01-34.27-27.89-62.16-62.15-62.16zm80.31-50.1h-40.86c-0.44 16.34-7.42 31.08-18.47 41.67 30.48 9.06 52.76 37.29 52.76 70.67v15.51c40.36-1.48 63.61-12.91 65.15-13.68l3.23-1.65h0.36v-50.38c-0.01-34.27-27.9-62.14-62.17-62.14zm-186.08-3.31c9.5 0 18.33-2.78 25.82-7.5 2.38-15.51 10.71-29.08 22.59-38.32 0.04-0.9 0.14-1.79 0.14-2.72 0-26.8-21.74-48.55-48.55-48.55-26.8 0-48.55 21.74-48.55 48.55 0 26.8 21.75 48.54 48.55 48.54zm43.61 44.98c-10.99-10.55-17.95-25.19-18.46-41.45-1.51-0.1-3.03-0.22-4.55-0.22h-41.19c-34.29 0-62.16 27.87-62.16 62.14v50.38l0.12 0.78 3.47 1.09c26.24 8.19 49.66 11.96 70.01 13.15v-15.21c-0.01-33.37 22.28-61.61 52.76-70.66z"
    />
    <path d="m4313.9 5812.4c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4z" />
    <path d="m1440.6-1120.3c-121.82-121.82-319.32-121.82-441.14 0s-121.82 319.32 0 441.14 319.32 121.82 441.14 0 121.82-319.33 0-441.14zm-413.89 413.89c-106.77-106.77-106.77-279.88 0-386.65s279.88-106.77 386.65 0 106.77 279.88 0 386.65-279.88 106.77-386.65 0z" />
    <path d="m1108.2-814.47l197.05-197.05c7.31-7.31 19.28-7.31 26.59 0s7.31 19.28 0 26.59l-197.05 197.05c-7.31 7.31-19.28 7.31-26.59 0s-7.31-19.27 0-26.59z" />
    <path d="m1305.2-787.87l-197.05-197.05c-7.31-7.31-7.31-19.28 0-26.59s19.28-7.31 26.59 0l197.05 197.05c7.31 7.31 7.31 19.28 0 26.59s-19.28 7.31-26.59 0z" />
    <path d="m4556.4 2168.5c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path
      className="st7"
      d="m4718 2411.8s-3.39-23.76-13.22-34.12c-12.5-13.58-26.62-13.76-32.87-14.65-46.1-3.39-115.23-3.39-115.23-3.39h-0.37s-68.95 0-115.06 3.39c-6.6 0.9-20.53 1.08-33.04 14.65-9.83 10.36-13.22 34.12-13.22 34.12s-3.4 27.87-3.4 55.38v26.27c0 27.87 3.4 55.39 3.4 55.39s3.39 23.76 13.22 34.3c12.5 13.75 28.95 13.22 36.45 14.65 26.26 2.68 112.02 3.58 112.02 3.58s69.14-0.36 115.23-3.58c6.25-0.89 20.37-0.89 32.87-14.65 9.84-10.54 13.22-34.3 13.22-34.3s3.21-27.52 3.21-55.39v-26.26c0-27.51-3.21-55.39-3.21-55.39zm-106.48 65.04l-89.16 48.05v-96.47l40.38 21.98 48.78 26.44z"
    />
    <path d="m1412.3 3850h-45.96c32.05 44.79 50.92 99.65 50.92 158.93 0 151-122.41 273.4-273.4 273.4s-273.4-122.41-273.4-273.4c0-151 122.41-273.4 273.4-273.4 1.65 0 3.29 0.03 4.94 0.06v-38.53c-1.64-0.03-3.29-0.06-4.94-0.06-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93c0.01-58.05-15.87-112.38-43.49-158.93z" />
    <path d="m1309.1 3736.5l-133.2 83.25c-2.69 1.68-5.76 2.53-8.83 2.53-2.77 0-5.55-0.69-8.07-2.09-5.29-2.93-8.58-8.5-8.58-14.56v-166.49c0-6.06 3.28-11.63 8.58-14.56 5.29-2.95 11.76-2.77 16.89 0.44l133.2 83.25c4.86 3.05 7.83 8.38 7.83 14.12 0.01 5.73-2.95 11.06-7.82 14.11z" />
    <path d="m1664.4 3850h45.96c-32.05 44.79-50.92 99.65-50.92 158.93 0 151 122.41 273.4 273.4 273.4s273.4-122.41 273.4-273.4c0-151-122.41-273.4-273.4-273.4-1.65 0-3.29 0.03-4.94 0.06v-38.53c1.64-0.03 3.29-0.06 4.94-0.06 172.28 0 311.93 139.66 311.93 311.93s-139.66 311.93-311.93 311.93-311.93-139.66-311.93-311.93c-0.01-58.05 15.87-112.38 43.49-158.93z" />
    <path d="m1767.5 3736.5l133.2 83.25c2.69 1.68 5.76 2.53 8.83 2.53 2.77 0 5.55-0.69 8.07-2.09 5.29-2.93 8.58-8.5 8.58-14.56v-166.49c0-6.06-3.28-11.63-8.58-14.56-5.29-2.95-11.76-2.77-16.89 0.44l-133.2 83.25c-4.86 3.05-7.83 8.38-7.83 14.12 0 5.73 2.96 11.06 7.82 14.11z" />
    <path d="m4436.1 3993.6l-215.87 134.91c-4.37 2.73-9.33 4.1-14.3 4.1-4.49 0-9-1.12-13.08-3.39-8.58-4.75-13.9-13.78-13.9-23.59v-269.83c0-9.82 5.32-18.84 13.9-23.6 8.57-4.78 19.06-4.49 27.38 0.72l215.87 134.91c7.88 4.94 12.68 13.58 12.68 22.88 0 9.31-4.8 17.95-12.68 22.89z" />
    <path d="m4448.8 4116.3v-291.15c0-10.34 8.46-18.8 18.81-18.8h20.19c10.34 0 18.8 8.46 18.8 18.8v291.15c0 10.34-8.46 18.8-18.8 18.8h-20.19c-10.35 0-18.81-8.46-18.81-18.8z" />
    <path
      className="st8"
      d="m2867.4 2327.5c-80.84 3.85-144.63 71.17-144.38 152.1 0.07 24.65 6.03 47.91 16.52 68.47l-16.12 78.23c-0.87 4.23 2.95 7.94 7.15 6.94l76.66-18.16c19.69 9.81 41.82 15.48 65.23 15.83 82.62 1.26 151.51-64.34 154.09-146.93 2.76-88.53-70.31-160.71-159.15-156.48zm91.47 235.68c-22.45 22.45-52.3 34.81-84.05 34.81-18.59 0-36.39-4.17-52.9-12.4l-10.68-5.32-47 11.14 9.89-48.03-5.26-10.3c-8.57-16.79-12.92-34.94-12.92-53.96 0-31.75 12.36-61.6 34.81-84.05 22.25-22.25 52.59-34.81 84.05-34.81 31.75 0 61.6 12.36 84.05 34.81s34.81 52.3 34.81 84.05c0.01 31.47-12.55 61.81-34.8 84.06z"
    />
    <path
      className="st8"
      d="m2948.5 2512l-29.4-8.44c-3.87-1.11-8.03-0.01-10.85 2.86l-7.19 7.33c-3.03 3.09-7.63 4.08-11.65 2.46-13.91-5.63-43.17-31.65-50.64-44.66-2.16-3.75-1.8-8.45 0.85-11.87l6.28-8.12c2.46-3.18 2.98-7.46 1.35-11.13l-12.37-27.98c-2.96-6.7-11.53-8.65-17.12-3.92-8.21 6.94-17.94 17.49-19.13 29.17-2.09 20.6 6.75 46.57 40.16 77.76 38.6 36.03 69.51 40.79 89.63 35.91 11.42-2.76 20.54-13.85 26.29-22.92 3.94-6.21 0.84-14.43-6.21-16.45z"
    />
    <path d="m2874.8 2168.4c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.93-139.66 311.93-311.93-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <text
      transform="translate(862.83 2022.4)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      COMPARTIR REDES
    </text>
    <text
      transform="translate(862.83 3338.1)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      PLAYER VIDEO Y AUDIO
    </text>
    <text
      transform="translate(797.61 5610.4)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      OTROS
    </text>
    <text
      transform="translate(862.83 847.24)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      Producción Video
    </text>
    <text
      transform="translate(862.83 -271.4)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      Home Slide
    </text>
    <text
      transform="translate(862.83 -1463)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      GENERALES
    </text>
    <text
      transform="translate(862.95 -2522.6)"
      fontFamily="'MyriadPro-Regular'"
      fontSize="120px"
    >
      TAB
    </text>
    <path d="m3574.9 3658.8c-172.28 0-311.93 139.66-311.93 311.93s139.66 311.93 311.93 311.93 311.94-139.65 311.94-311.93-139.66-311.93-311.94-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4 0-151 122.41-273.4 273.4-273.4s273.4 122.41 273.4 273.4c0.01 150.99-122.4 273.4-273.4 273.4z" />
    <path d="m3595.8 4103.7v-265.89c0-10.34 8.46-18.8 18.8-18.8s18.8 8.46 18.8 18.8v265.89c0 10.34-8.46 18.8-18.8 18.8-10.33 0-18.8-8.46-18.8-18.8z" />
    <path d="m3516.4 4103.7v-265.89c0-10.34 8.46-18.8 18.8-18.8s18.8 8.46 18.8 18.8v265.89c0 10.34-8.46 18.8-18.8 18.8-10.33 0-18.8-8.46-18.8-18.8z" />
    <path d="m1421.5 4921.3c0-172.28-139.66-311.93-311.93-311.93s-311.93 139.66-311.93 311.93 139.66 311.93 311.93 311.93 311.93-139.65 311.93-311.93zm-585.34 0c0-151 122.41-273.4 273.4-273.4s273.4 122.41 273.4 273.4-122.41 273.4-273.4 273.4-273.4-122.4-273.4-273.4z" />
    <text
      transform="translate(1014.7 5091.1)"
      fontFamily="'Dosis-ExtraBold'"
      fontSize="415.1px"
    >
      ?
    </text>
    <path d="m2565.9 4825.5v192.66h221.3l44.47 55.84v-54.81h69.29v-194.41l-335.06 0.72zm109.37 97.37c0-2.96 2.4-5.37 5.37-5.37h76.67c2.96 0 5.37 2.4 5.37 5.37v10.98c0 2.96-2.4 5.37-5.37 5.37h-76.67c-2.96 0-5.37-2.4-5.37-5.37v-10.98zm-76.18 0c0-2.96 2.4-5.37 5.37-5.37h45.76c2.96 0 5.37 2.4 5.37 5.37v10.98c0 2.96-2.4 5.37-5.37 5.37h-45.76c-2.96 0-5.37-2.4-5.37-5.37v-10.98zm99.87 58.2c0 2.96-2.4 5.37-5.37 5.37h-89.13c-2.96 0-5.37-2.4-5.37-5.37v-10.98c0-2.96 2.4-5.37 5.37-5.37h89.13c2.96 0 5.37 2.4 5.37 5.37v10.98zm78.59 0c0 2.96-2.4 5.37-5.37 5.37h-42.41c-2.96 0-5.37-2.4-5.37-5.37v-10.98c0-2.96 2.4-5.37 5.37-5.37h42.41c2.96 0 5.37 2.4 5.37 5.37v10.98zm80.01-47.22c0 2.96-2.4 5.37-5.37 5.37h-57.88c-2.96 0-5.37-2.4-5.37-5.37v-10.98c0-2.96 2.4-5.37 5.37-5.37h57.88c2.96 0 5.37 2.4 5.37 5.37v10.98z" />
    <path d="m2733.4 4637.4c-172.28 0-311.93 139.66-311.93 311.93 0 172.28 139.66 311.93 311.93 311.93s311.93-139.66 311.93-311.93c0-172.28-139.65-311.93-311.93-311.93zm0 585.34c-151 0-273.4-122.41-273.4-273.4s122.41-273.4 273.4-273.4 273.4 122.41 273.4 273.4-122.4 273.4-273.4 273.4z" />
    <path d="m935.81-2185.5c2.08-2.4 3.84-5.2 6.28-7.16 49.96-40.16 99.99-80.23 150.01-120.32 6.36-5.1 9.53-5.13 15.88-0.04 50.12 40.16 100.23 80.33 150.37 120.47 3.13 2.5 5.99 5.11 5.75 9.49-0.2 3.62-1.96 6.45-5.34 7.99-3.65 1.67-7.06 1.03-10.16-1.46-9.65-7.74-19.3-15.47-28.96-23.21-39-31.25-78.02-62.48-116.97-93.81-2.16-1.74-3.4-1.45-5.37 0.14-46.47 37.32-92.98 74.6-139.54 111.8-2.38 1.9-3.3 3.79-3.3 6.86 0.09 72.87 0.07 145.73 0.07 218.6v4.56h172.29v-94.18h-53.86v3.89 65.62c0 1 0.04 2-0.01 3-0.28 5.68-4.22 9.71-9.4 9.67-5.19-0.05-9.04-4.14-9.23-9.81-0.03-1-0.01-2-0.01-3 0-25.75-0.01-51.49 0.01-77.24 0.01-7.43 3.59-11.03 11.04-11.04 23.12-0.03 46.24-0.03 69.37 0 7.45 0.01 11.03 3.62 11.04 11.05 0.02 32.37 0.01 64.74 0.01 97.11v4.8h99.77v-4.24-157.48c0-1.37-0.06-2.76 0.05-4.12 0.38-4.65 3.9-8.25 8.38-8.66 4.72-0.42 8.83 2.56 9.86 7.34 0.34 1.57 0.34 3.22 0.34 4.84 0.02 56.24-0.04 112.49 0.09 168.73 0.01 5.67-1.59 9.92-6.72 12.56h-315l-6.75-7.5c0.01-81.75 0.01-163.5 0.01-245.25z" />
    <path d="m2331.4-2053.4c6.99 6.76 13.96 13.33 20.74 20.09 24.18 24.08 48.28 48.24 72.45 72.33 5.16 5.14 7.43 11.05 5.04 18.15-2.11 6.26-6.74 9.82-13.2 10.78-5.69 0.85-10.46-1.24-14.46-5.24-21.87-21.87-43.74-43.73-65.61-65.6-8.58-8.58-17.16-17.15-25.75-25.72-0.64-0.64-1.39-1.17-2.21-1.86-40.78 31.78-86.58 43.53-137.24 33.67-40.77-7.94-73.67-29.26-99.02-62.11-49.8-64.51-43.37-157.82 14.82-216.39 57.75-58.12 151.08-64.92 216-15.37 37.07 28.29 59.06 65.73 64.7 112.14 5.61 46.38-7.04 87.83-36.26 125.13zm-259.96-105.14c0.04 72.92 59.55 132.33 132.47 132.28 72.92-0.06 132.36-59.56 132.3-132.47-0.06-72.92-59.58-132.34-132.49-132.26-72.99 0.08-132.32 59.49-132.28 132.45z" />
    <path
      className="st9"
      d="m3570.7-2162.5c40.23-17.96 68.31-58.23 68.31-105.13 0-63.6-51.56-115.15-115.15-115.15s-115.15 51.56-115.15 115.15c0 46.43 27.53 86.33 67.11 104.55-87.57 20.29-153.56 96.63-158.11 189.29h25.31c5.29-94.44 83.32-169.45 179.08-169.45s173.79 75.01 179.08 169.45h25.31c-4.51-91.84-69.38-167.61-155.79-188.71zm-138.03-105.13c0-55.74 35.45-91.19 91.19-91.19s91.19 35.45 91.19 91.19-35.45 91.19-91.19 91.19-91.19-35.45-91.19-91.19z"
    />
    <path
      className="st8"
      d="m2887.3-1925.4h-38.22c-2.03 0-3.67-1.64-3.67-3.67v-384.05c0-2.03 1.64-3.67 3.67-3.67h38.22c2.03 0 3.67 1.64 3.67 3.67v384.05c0 2.03-1.64 3.67-3.67 3.67z"
    />
    <path
      className="st8"
      d="m2803.7-2001.2h-38.22c-2.03 0-3.67-1.64-3.67-3.67v-232.57c0-2.03 1.64-3.67 3.67-3.67h38.22c2.03 0 3.67 1.64 3.67 3.67v232.57c0 2.03-1.65 3.67-3.67 3.67z"
    />
    <path
      className="st8"
      d="m2720.1-2062.5h-38.22c-2.03 0-3.67-1.64-3.67-3.67v-109.88c0-2.03 1.64-3.67 3.67-3.67h38.22c2.03 0 3.67 1.64 3.67 3.67v109.88c0 2.03-1.64 3.67-3.67 3.67z"
    />
    <path
      className="st8"
      d="m2932.7-2001.2h38.22c2.03 0 3.67-1.64 3.67-3.67v-232.57c0-2.03-1.64-3.67-3.67-3.67h-38.22c-2.03 0-3.67 1.64-3.67 3.67v232.57c0.01 2.03 1.65 3.67 3.67 3.67z"
    />
    <path
      className="st8"
      d="m3016.3-2062.5h38.22c2.03 0 3.67-1.64 3.67-3.67v-109.88c0-2.03-1.64-3.67-3.67-3.67h-38.22c-2.03 0-3.67 1.64-3.67 3.67v109.88c0 2.03 1.64 3.67 3.67 3.67z"
    />
    <path d="m1649.3-2316.8c-108.08 0-195.69 87.61-195.69 195.69s87.61 195.69 195.69 195.69 195.69-87.61 195.69-195.69c0-108.07-87.61-195.69-195.69-195.69zm0 367.22c-94.73 0-171.52-76.79-171.52-171.52s76.79-171.52 171.52-171.52 171.52 76.79 171.52 171.52c0 94.72-76.79 171.52-171.52 171.52z" />
    <path d="m1711.7-2111.8l-88.11 55.07c-1.78 1.11-3.81 1.67-5.84 1.67-1.83 0-3.67-0.46-5.34-1.39-3.5-1.94-5.67-5.62-5.67-9.63v-110.14c0-4.01 2.17-7.69 5.67-9.63 3.5-1.95 7.78-1.83 11.18 0.29l88.11 55.07c3.22 2.02 5.18 5.54 5.18 9.34s-1.96 7.33-5.18 9.35z" />
    <path d="m4775 3947.8l215.87-134.91c4.37-2.73 9.33-4.1 14.3-4.1 4.49 0 9 1.12 13.08 3.39 8.58 4.75 13.9 13.78 13.9 23.59v269.83c0 9.81-5.32 18.84-13.9 23.6-8.57 4.78-19.06 4.49-27.38-0.72l-215.87-134.91c-7.88-4.94-12.68-13.58-12.68-22.88s4.8-17.95 12.68-22.89z" />
    <path d="m4762.3 3825.2v291.15c0 10.34-8.46 18.8-18.81 18.8h-20.19c-10.34 0-18.8-8.46-18.8-18.8v-291.15c0-10.34 8.46-18.8 18.8-18.8h20.19c10.35-0.01 18.81 8.46 18.81 18.8z" />
    <polygon
      className="st10"
      points="2627.9 -898.94 2896.6 -898.94 2896.6 -941.06 2627.9 -941.06 2741.6 -1050 2712.6 -1079 2551 -922.77 2713.6 -758.48 2741.4 -783"
    />
    <path
      className="st8"
      d="m344.79 623.87h-65.29c-2.03 0-3.67-1.64-3.67-3.67v-616.53c0-2.03 1.64-3.67 3.67-3.67h65.28c2.03 0 3.67 1.64 3.67 3.67v616.53c0 2.03-1.64 3.67-3.66 3.67z"
    />
    <path
      className="st8"
      d="m211.54 503.14h-65.28c-2.03 0-3.67-1.64-3.67-3.67v-375.07c0-2.03 1.64-3.67 3.67-3.67h65.28c2.03 0 3.67 1.64 3.67 3.67v375.08c-0.01 2.02-1.65 3.66-3.67 3.66z"
    />
    <path
      className="st8"
      d="m78.29 405.35h-65.28c-2.03 0-3.67-1.64-3.67-3.67v-179.5c0-2.03 1.64-3.67 3.67-3.67h65.28c2.03 0 3.67 1.64 3.67 3.67v179.5c0 2.03-1.65 3.67-3.67 3.67z"
    />
    <path
      className="st8"
      d="m412.75 503.14h65.28c2.03 0 3.67-1.64 3.67-3.67v-375.07c0-2.03-1.64-3.67-3.67-3.67h-65.28c-2.03 0-3.67 1.64-3.67 3.67v375.08c0 2.02 1.64 3.66 3.67 3.66z"
    />
    <path
      className="st8"
      d="m546 405.35h65.28c2.03 0 3.67-1.64 3.67-3.67v-179.5c0-2.03-1.64-3.67-3.67-3.67h-65.28c-2.03 0-3.67 1.64-3.67 3.67v179.5c0 2.03 1.64 3.67 3.67 3.67z"
    />
  </SvgIcon>
);
const PlayCircle = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 623.87 623.87"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path
      fill={color || Colors.white}
      d="M311.93,0C139.66,0,0,139.66,0,311.93S139.66,623.87,311.93,623.87,623.87,484.21,623.87,311.93,484.21,0,311.93,0Zm0,585.34c-151,0-273.4-122.41-273.4-273.41s122.41-273.4,273.4-273.4,273.41,122.41,273.41,273.4S462.93,585.34,311.93,585.34Z"
    />
    <path
      fill={color || Colors.white}
      d="M418.47,326.83,278,414.61a17.56,17.56,0,0,1-26.86-14.89V224.16A17.55,17.55,0,0,1,278,209.27l140.46,87.78a17.56,17.56,0,0,1,0,29.78Z"
    />
  </SvgIcon>
);

const ArrowDownIcon = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320.6 345.7"
    width={getKey(size, "width", size)}
    height={getKey(size, "height", size)}
    className={className}
  >
    <polygon
      points="180.1,268.7 180.1,0 138,0 138,268.7 29,155.1 0,184.1 156.3,345.7 320.6,183 296,155.3 "
      fill={color || "#1A1414"}
    />
  </SvgIcon>
);

const IconNinos = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 82 40"
    width={getKey(size, "width", size)}
    height={getKey(size, "height", size)}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <image xlinkHref="data:image/png;base64,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" />
  </SvgIcon>
);

const CalendarCircle = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <image
      id="Objeto_inteligente_vectorial"
      data-name="Objeto inteligente vectorial"
      width="32"
      height="32"
      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADw0lEQVRYhcWXSWyNURTHf+95JZpWTImhpgoRQ2paaBsSLIiFRCJiSEosxLCykpaVFcpKItgZEwsNYiE2SMjTEFJjF6qtISFCVI0paeWk/8vX797Pe62If/Llfe8O53/uuef+7/lSbfcqyRPDgBXAIqAMKAWKNPUT0ALcB64C54F3+ZjNxwEjqwFWAgVebxjfgTpgj5xKRDqpAygGDgMNwBqR3wR2AguBEqBQT4nadmpMgeY0yEaxZz1HBKYrjJOALuAksBdo9EaGMRWoBqqMA2jS9j2Kjw5FoBzIirwZmA9s6AU5GrtBc5tlKyvbf3TAVn4ZGARcAeZqYl+RlY0rsnlZHEEHihV2R74MaPsLcoc22XJOnI/mRNSB2kjYLeM7In2WVDM80z0x22v5jQ7ZdNtRG3fAjtpmJVxVYOXzgAue2Z64DYz1WntGokocm8VJRp01ytYTgT03j0cC/RSF4Z5peKn+8fr/whvRjaxO1HpxrrVjaAr3SmGeFsv26RKS/cAEYDSwwDMLp4FRwENgk8a+8UZ1w47oY4nVqLTOpxOZ+FGbrG3aBoxLIDesUzS3AAPlaBIaI2K1IiNtN1xMmNCpx6Lzwev9jZnAV6C/1+PDuCqMO+OSIbD3Dg8kIJYHP4DXwBj1PVdk3HtnIIFDcFxlGd1qhieBgQ7luuWeSfNb1D4k9p6vbjiu0kzkSn3vDes9UjolP3LMdFxFobsghGsybtndqveUVpxSZtvx+ibRMU1YGrDjIa1iAoUwCQslIK1yokuPYQpQDzyVTlh+HAPOAqsT7DmuT+nIHk72huWHAyLcLlIL/yFgI3AwoYhxXC3pSMUSLAyEeiXrfKleaSR5l4gQKWGh3uv0G7ojHNf9tLLbsNwb1q1YU3T0GqR0b/XeIPGxFX7R+A4t6I2qpM8JEXBcV3NJMTr/Iz0T3TAnbgGnFG7ThKFyxCJxHRgBtEfm9JDijKrXOtVw1apkonitJwm7gHNaxFkJkhUhZ3TttsfmVevXON+5mrBMq0H7nKSKSVilCPRT2C1i+4DdkdOC9v6G3mfZdkWL0sO6TJq1gt5WQwW6DwYoDz7G+gcDd4CJwBFgqzVGHbAy6a7uf1eSdXg0fYNdUJeAxaqQ5zgHo0r4UVdzuwZektd/i8ER8nZx/IpOXIofSUKdE3dy6EMuVMqGI18a/zYI3QX1mtik/bKkOa7jky+mas4N2WiSzfr4/KQvI5QTtSogU2q7qWIiqyvV3WpDJK+VEpkKtdsJOArsCCRlTgcc/unH6f/9PAd+Anv3+cHBm3INAAAAAElFTkSuQmCC"
    />
  </SvgIcon>
);

const LiveStream = ({ size, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    width={size}
    height={size}
    focusable="false"
    aria-hidden={true}
    className={className}
    fill="none"
  >
    <image
      id="image0"
      width="17"
      height="17"
      x="0"
      y="0"
      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAY1BMVEX/////AAD/////////
////////////////////////ycn/Pz//Bwj/AAD/////kJD/AQH/////////////x8f/AQH/////
Pj7/////Bwj/////////Pz//////////AAD///89u+5uAAAAH3RSTlMAAAY5YHeALXRAj8vw/C6k
+XYINpD4Xcxz8X1ezC9hzK6H9QAAAAFiS0dEAIgFHUgAAAAHdElNRQfkBw4ELhgMnGGxAAAAiklE
QVQY022QWRKDIBBEB9B2YZHEFTXh/rcUQoJlxfc11TVL9xAFuChKlIXg9KWqkairJDQ4aVjsCEUr
lVayDZUJO8JIZ33EdsDjST0wjD5hB6CnCZj9DwlMtAAuKwpYaAV0VjSw3vRc9szA9rllL7f+/ZCJ
nnen3R49v25zETM5u2Espefiff7nAB5MD5vv+AofAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTA3
LTE0VDA0OjQ2OjI0KzAzOjAwzJSPrgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wNy0xNFQwNDo0
NjoyNCswMzowML3JNxIAAAAASUVORK5CYII="
    />
  </SvgIcon>
);

const IconArrowDropDown = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 244.8 199.3"
    width={`${getKey(size, "width", size)}px`}
    height={`${getKey(size, "height", size)}px`}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <polygon points="0.6,79.5 0.6,4.1 122.5,124.3 244.5,4.1 244.5,79.5 122.5,193.8 " />
  </SvgIcon>
);

const TreeDots = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={`${getKey(size, "width", size)}px`}
    height={`${getKey(size, "height", size)}px`}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path
        d="M2345 4629 c-301 -32 -624 -143 -882 -302 -913 -567 -1245 -1751
-757 -2707 345 -676 1013 -1104 1774 -1137 975 -41 1854 616 2095 1566 154
608 24 1258 -353 1760 -71 95 -243 273 -343 357 -237 198 -561 356 -867 424
-203 45 -465 60 -667 39z m403 -320 c324 -35 653 -169 902 -367 71 -57 227
-211 280 -277 373 -470 486 -1093 300 -1658 -42 -128 -157 -354 -237 -467 -87
-122 -291 -326 -413 -413 -113 -80 -339 -195 -467 -237 -620 -204 -1308 -47
-1771 404 -161 156 -260 291 -356 484 -309 615 -226 1357 211 1895 147 180
371 357 590 467 171 85 419 156 608 173 89 8 261 6 353 -4z"
      />
      <path
        d="M2480 3747 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -239 51
-52 102 -75 165 -75 124 0 240 116 240 240 0 63 -23 114 -75 165 -70 71 -152
91 -245 62z"
      />
      <path
        d="M2480 2787 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -239
101 -102 229 -102 330 0 98 97 101 222 8 325 -65 72 -158 97 -253 67z"
      />
      <path
        d="M2480 1827 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -239 70
-71 145 -91 239 -63 55 16 138 99 154 154 28 94 8 169 -63 239 -70 71 -152 91
-245 62z"
      />
    </g>
  </SvgIcon>
);

const Sort = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.000000 512.000000"
    width={`${getKey(size, "width", size)}px`}
    height={`${getKey(size, "height", size)}px`}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path
        d="M1425 4915 c-17 -9 -297 -282 -622 -608 -517 -517 -592 -597 -598
-629 -12 -65 7 -96 148 -236 209 -208 201 -209 489 75 l208 206 42 -6 c29 -4
50 -14 65 -32 l23 -26 0 -1071 c0 -1054 0 -1072 20 -1112 38 -77 50 -81 262
-84 209 -4 235 2 279 61 l24 32 5 1085 c3 597 9 1093 14 1103 10 21 57 47 86
47 40 0 76 -30 265 -220 207 -207 225 -219 300 -199 31 9 68 39 162 132 67 66
129 135 138 153 21 44 19 93 -6 133 -33 54 -1160 1182 -1196 1197 -41 18 -70
17 -108 -1z"
      />
      <path
        d="M3432 3724 c-18 -9 -43 -31 -55 -48 l-22 -31 -5 -1085 c-3 -597 -9
-1093 -14 -1103 -10 -21 -57 -47 -86 -47 -40 0 -76 30 -265 220 -211 212 -228
223 -306 196 -33 -12 -69 -43 -158 -137 -64 -67 -124 -135 -133 -152 -22 -38
-23 -89 -4 -125 8 -15 282 -293 608 -619 473 -471 600 -592 625 -598 77 -16
63 -28 695 603 591 592 597 597 603 645 5 30 3 58 -5 77 -7 16 -70 85 -140
154 -208 202 -205 203 -492 -81 l-208 -206 -42 6 c-29 4 -50 14 -65 32 l-23
26 0 1081 c0 1064 0 1082 -20 1122 -38 77 -50 81 -265 84 -160 2 -195 0 -223
-14z"
      />
    </g>
  </SvgIcon>
);

const X = ({ size, color, className }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 271"
    width={`${getKey(size, "width", size)}px`}
    height={`${getKey(size, "height", size)}px`}
    focusable="false"
    aria-hidden={true}
    color={color}
    className={className}
  >
    <path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/>
  </SvgIcon>
);

const Icons = {
  star: Star,
  search: Search,
  User,
  userCircle: UserCircle,
  chevronBottom: ChevronBottomIcon,
  chevronBottomB: ChevronBottomIconB,
  chevronRight,
  OndemandVideo,
  Video,
  Info,
  InfoCustom,
  Share,
  ShareCustom,
  LikeDeselectedCustom,
  DislikeDeselectedCustom,
  MyListCustom,
  PlusSmall,
  ShareAlt,
  Plus,
  FacebookF,
  Twitter,
  Youtube,
  Instagram,
  KeyboardArrowRight,
  KeyboardArrowLeft,
  BrokenImage,
  Image,
  Email,
  GooglePlusG,
  Whatsapp,
  Bars,
  Close,
  CloseO,
  CloseCircle,
  ArrowDropUp,
  ArrowDropDown,
  ArrowBack,
  PlayCircle,
  PlayFaCircle,
  PauseCircle,
  VolumeUp,
  VolumeOff,
  Speaker,
  SpeakerNew,
  Trailer,
  FileDownload,
  Backward,
  Forward,
  PlayCircleFilled,
  VolumeDown,
  VolumeMute,
  PauseCircleFilled,
  CalendarCircle,
  Spinner,
  LiveStream,
  ListUl: FormatListBulleted,
  Warning,
  MinusCircle,
  Error,
  ErrorOutline,
  StepBackward,
  StepForward,
  IconNinos,
  PauseCircleCustom,
  Pause,
  IconArrowDropDown,
  ArrowDownIcon,
  Heart,
  TreeDots,
  Sort,
  X,
};

export default Icons;
